import * as React from "react";
import { forwardRef } from "react";
const MicrophoneSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M7 7a5 5 0 0 1 10 0v4a5 5 0 0 1-10 0zm5-3a3 3 0 0 0-3 3v4a3 3 0 1 0 6 0V7a3 3 0 0 0-3-3", clipRule: "evenodd" }),
    React.createElement("path", { d: "M11 19.945V22a1 1 0 1 0 2 0v-2.055c3.834-.425 7-3.256 7-6.945a1 1 0 1 0-2 0c0 2.622-2.536 5-6 5s-6-2.378-6-5a1 1 0 1 0-2 0c0 3.689 3.166 6.52 7 6.945" }));
const ForwardRef = forwardRef(MicrophoneSVG);
export default ForwardRef;
//# sourceMappingURL=Microphone.js.map